'use client';

import { RESPONSIVE_MARGIN } from '@/functions/createTheme';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import type React from 'react';
import { useMemo } from 'react';

type Props = {
  cityDomain: string;
  customerSetting: IbarakiRegionSetting;
};

export const AreaTable: React.FC<Props> = ({ cityDomain, customerSetting }) => {
  const theme = useTheme();
  const areas = useMemo(() => {
    const city = customerSetting.cities[cityDomain];
    return customerSetting.areas.filter((area) => area.cityId === city.cityId);
  }, [customerSetting, cityDomain]);

  return (
    <>
      <Box sx={{ my: RESPONSIVE_MARGIN }}>
        <Typography variant="body1">
          当サイトでのエリアの定義については以下のとおりです。
        </Typography>
      </Box>
      <Box sx={{ my: RESPONSIVE_MARGIN }}>
        <Table size="small">
          <TableHead
            sx={{ borderBottom: `2px solid ${theme.palette.divider}` }}
          >
            <TableRow>
              <TableCell>エリア名</TableCell>
              <TableCell>町名</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {areas.map(({ areaName, towns }, i) =>
              towns.map(({ townName }, j) => (
                <TableRow
                  key={`area-${i}-${j}`}
                  sx={{
                    borderBottom:
                      j === towns.length - 1
                        ? `2px solid ${theme.palette.divider}`
                        : undefined
                  }}
                >
                  <TableCell>{areaName}</TableCell>
                  <TableCell>{townName}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </Box>
    </>
  );
};
